import { useState } from 'react';
import { DiamondIcon } from '@THC/components/Icons/Diamond';

import { TickIcon } from '@motorway/mw-highway-code';

import ExpandableListItem from 'Components/shared/ExpandableListItem/ExpandableListItem';

import styles from './ExLeaseSection.module.scss';

const EX_LEASE_DESCRIPTION = 'Ex-lease vehicles you won\u0027t find anywhere else.';

const EX_LEASE_BENEFITS = [
	'Winning bids at or above reserve are guaranteed accepted',
	'£100 off fees',
	'BVRLA inspected at collection',
	'Motorway Move delivered',
];

const EX_LEASE_SECTION_ID = 'ex-lease-benefits';

export const ExLeaseSection: React.FC = () => {
	const [isExpanded, setIsExpanded] = useState(true);

	return (
		<div className={styles.container} data-testid="ex-lease-section">
			<p className={styles.description}>{EX_LEASE_DESCRIPTION}</p>
			<div className={styles.expandableWrapper}>
				<ExpandableListItem
					isSmall
					classNames={{
						container: styles.expandable,
						content: styles.expandableContent,
						header: styles.expandableHeader,
						title: styles.expandableTitle,
					}}
					id={EX_LEASE_SECTION_ID}
					isExpanded={isExpanded}
					onClick={() => setIsExpanded(!isExpanded)}
					title={
						<span className={styles.titleContent}>
							<DiamondIcon size="xsmall" />
							What makes these vehicles special?
						</span>
					}
				>
					<ul className={styles.benefitsList}>
						{EX_LEASE_BENEFITS.map((benefit) => (
							<li key={benefit} className={styles.benefitItem}>
								<span className={styles.tickIcon}>
									<TickIcon size="xsmall" />
								</span>
								<span>{benefit}</span>
							</li>
						))}
					</ul>
				</ExpandableListItem>
			</div>
		</div>
	);
};
